"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Houses = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _HousesFilters = require("./inner/HousesFilters");
var _Row = require("../Grid/Row");
var _Cell = require("../Grid/Cell");
var _Escrow = require("./inner/Escrow");
var _Footer = require("../Footer/Footer");
var _Documents = require("./inner/Documents");
var _Deadlines = require("../Deadlines/Deadlines");
var _Deadline = require("../Deadlines/Deadline");
var styles = _interopRequireWildcard(require("./Houses.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Houses = _ref => {
  let {
    houses,
    onEscrowIconClick
  } = _ref;
  const [selectedHouseId, setOpenHouseId] = React.useState(houses[0]?.id);
  const currentHouse = houses.find(house => house.id === selectedHouseId) || houses[0];
  if (!selectedHouseId) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, "\u041A\u043E\u0440\u043F\u0443\u0441\u0430")), /*#__PURE__*/React.createElement("div", {
    className: styles['filters']
  }, houses.length > 1 ? /*#__PURE__*/React.createElement(_HousesFilters.HousesFilters, {
    houses: houses,
    selectedHouseId: selectedHouseId,
    onClick: setOpenHouseId
  }) : houses[0].name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Row.Row, null, /*#__PURE__*/React.createElement(_Cell.Cell, null, /*#__PURE__*/React.createElement(_Escrow.Escrow, {
    onEscrowIconClick: onEscrowIconClick,
    escrow: currentHouse.escrow
  }))), /*#__PURE__*/React.createElement(_Deadlines.Deadlines, null, currentHouse.deadlines.map((deadline, i) => {
    return /*#__PURE__*/React.createElement(_Deadline.Deadline, {
      key: i,
      deadline: deadline
    });
  })), /*#__PURE__*/React.createElement(_Documents.Documents, {
    documents: currentHouse.documents,
    documentsCount: currentHouse.documentsCount,
    documentsCountHasWarning: currentHouse.documentsCountHasWarning
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Footer.Footer, {
    fullwidth: false,
    url: currentHouse.offersLink
  })));
};
exports.Houses = Houses;